import { useEffect, useState } from 'react'

/**
 * Retorna o offset (em px) que elementos `fixed bottom-0` precisam aplicar
 * para ficar VISÍVEIS quando o teclado virtual cobre o viewport em mobile.
 *
 * Usa a `window.visualViewport` API (suportada em todos os browsers móveis
 * modernos). Sem teclado aberto retorna 0; com teclado retorna a altura que
 * o teclado está cobrindo do bottom da janela.
 *
 * Aplicar como `style={{ bottom: offset }}` ou `paddingBottom`.
 */
export function useViewportOffset(): number {
  const [offset, setOffset] = useState(0)

  useEffect(() => {
    if (typeof window === 'undefined' || !window.visualViewport) return

    const vv = window.visualViewport
    const update = () => {
      // diferença entre altura "real" da janela e a área visível atual.
      // Com teclado aberto, vv.height encolhe — guardamos esse delta.
      const delta = window.innerHeight - vv.height - vv.offsetTop
      setOffset(delta > 0 ? delta : 0)
    }

    update()
    vv.addEventListener('resize', update)
    vv.addEventListener('scroll', update)
    return () => {
      vv.removeEventListener('resize', update)
      vv.removeEventListener('scroll', update)
    }
  }, [])

  return offset
}
